import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CompatibilityService {

  constructor() { }

  supportsWebGl () {
    // Create canvas element. The canvas is not added to the document itself, so it is never displayed in the
    // browser window.
    const canvas = document.createElement('canvas');
    // Get WebGLRenderingContext from canvas element.
    const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
    // Report the result.
    return (gl && gl instanceof WebGLRenderingContext);
  }
  
  isHoverSupported(): boolean {
    return window.matchMedia( '(hover: hover)' ).matches;
  }

}
